<!--- FORMULARIO Gestionar Salidas de producción  ---->
<!---
CASO DE USO:
Descripción del formulario:
---------------------------
- Formulario donde se permite gestionar las salidas de producción.
--->

<template>
  <f7-page class="main-manageproductionoutputs">
    <div class="content-menu">
      <PCSideNavbar />
    </div>
    <div class="content-data padding-half">
      <div class="content-header padding-bottom-half">
        <div class="content-header__actions">
          <div
            class="content-header__actions--button margin-left"
            :class="{
              'div-elementoTarjetaLineaDeshabilitada': counterCallsPendingAnswerInFrm !== 0 || lineSelected == null ? true : false,
            }"
            @click="UpdateDataFrm()"
          >
            <img
              alt="iconUpdate"
              src="@/static/img/ic_update.svg"
            >
            <span>Actualizar</span>
          </div>
          <div class="margin-left margin-right line-production">
            <UCSearchEntityERP
              :placeholder="$t('common.productionLine')"
              :search-text="$t('searchEntity.line.searchText')"
              :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
              :default-value="lineSelectedAtStartForm"
              :default-etities-list="lineasProduccion"
              :property-entity-shown-input="['Codigo', 'Nombre']"
              :property-entity-shown-list-title="['Codigo']"
              :property-entity-shown-list-subtitle="['Nombre']"
              :min-text-search="0"
              :disabled="counterCallsPendingAnswerInFrm === 0 ? false : true"
              :next-and-previous-buttons-shown="true"
              :autofocus-on-deselection="true"
              :auto-focus-on-empty-search-result="true"
              :emit-evet-change-default-value="true"
              @selection="EventLineProductionSelected"
            />
          </div>
        </div>
        <div class="content-header__logo margin-horizontal-half">
          <img
            v-if="logoApp"
            id="logo"
            alt="logoCliente"
            :src="logoApp"
          >
          <img
            v-else
            id="logo"
            alt="logoHispatec"
            :src="LOGO_HISPATEC"
          >
        </div>
      </div>
      <f7-row class="content-body">
        <f7-col
          width="30"
          class="content-planned"
        >
          <div class="content-planned__title">
            <span>
              PUNTOS DE PALETIZADO
            </span>
            <f7-button
              class="button-asigned"
              :disabled="palletisingPointSelected === null || puntoDePaletizadoSeleccionado === null"
            >
              <img
                alt="addButton"
                src="@/static/icons/ic_add_new.svg"
                height="28"
                width="28"
                @click="popupPedidosPlanificados = true; addButtonPressed = true"
              >
            </f7-button>
          </div>
          <div class="content-planned__results--cards">
            <div>
              <f7-list
                accordion-list
                accordion-opposite
              >
                <f7-list-item
                  v-for="(e, i) in lstPalletisingPointAndConfection"
                  :key="i + 2"
                  :title="e.PuntoPaletizado.Nombre"
                  accordion-item
                  @accordion:open="EventPalletizingPointSelected(e)"
                  @accordion:beforeclose=" palletisingPointSelected = null"
                  @accordion:closed="lstLots = []"
                  @accordion:beforeopen="onBeforeOpen()"
                >
                  <div v-if="e.Planificaciones.length !== 0">
                    <f7-accordion-content
                      v-for="(plani, p) in e.Planificaciones"
                      :key="p + 1"
                    >
                      <UCPreload :show="showPlanPreload" />
                      <UCCardGH
                        :state="plani.TipoEstado"
                        :title="`${`${plani.Pedido}-${plani.Orden} ${plani.NombreCliente}`}`"
                        :card-title="plani.Producto.Nombre"
                        :card-sub-title="`${`${plani.Pale.Nombre} ${plani.Envase.Nombre}`}`"
                        :footer-item-ref="plani.ReferenciaPedidoVenta"
                        :number-packages="`${plani.CantidadEnvasesPorPalet * plani.CantidadPalet}`"
                        :number-palets="`${plani.CantidadPalet}`"
                      >
                        <template #buttons>
                          <f7-button
                            class="content-button"
                            @click="OpenImagenesEntidad(plani)"
                          >
                            <img
                              :src="GalleryIcon"
                              width="30px"
                            >
                          </f7-button>
                        </template>
                      </UCCardGH>
                    </f7-accordion-content>
                  </div>
                  <div v-else>
                    <f7-accordion-content>
                      <UCPreload :show="showPlanPreload" />
                      <span
                        v-if="!showPlanPreload"
                        class="display-flex justify-content-center padding-half"
                      > Sin planificaciones </span>
                    </f7-accordion-content>
                  </div>
                </f7-list-item>
              </f7-list>
            </div>
          </div>
          <div class="content-planned__title">
            <span>HISTÓRICO DE LOTES</span>
          </div>
          <div class="content-planned__results--lotes padding-half">
            <UCPreload
              :show="showLotsPreload"
              :number="1"
            />
            <f7-list>
              <f7-list-item
                v-for="(lote, i) in lstLots"
                :key="i"
                :class="lote.FechaFin !== '1900-01-01T00:00:00' ? 'item-500' : 'item-600'"
              >
                <template #after>
                  <div>
                    {{ FormatDate(lote.FechaInicio) }}
                  </div>
                </template>

                <template #title>
                  <div>
                    <img
                      v-if="lote.FechaFin === '1900-01-01T00:00:00' || lote.FechaFin === null"
                      alt="iconEclipseOrange"
                      src="@/static/img/ic_elipse_orange.svg"
                    >
                    <img
                      v-else
                      alt="iconEclipseGreen"
                      src="@/static/img/ic_elipse_grey.svg"
                    >
                    <span
                      v-if="lote.Lote != null"
                      class="padding-left-half"
                    > {{ lote.Lote.Codigo }} </span>
                  </div>
                </template>
              </f7-list-item>
            </f7-list>
          </div>
        </f7-col>
        <f7-col
          width="70"
          class="content-pending"
        >
          <div class="content-pending__title">
            <span>SALIDAS DE PRODUCCIÓN</span>
          </div>
          <div class="content-pending__filters">
            <f7-checkbox
              class="content-pending__filters__checkbox"
              :checked="filteredSelectedList.length > 0 && filteredSelectedList.length === lstSelected.length"
              @change="EventAllSelected"
            >
              <span class="padding-left-half">
                {{ $t('common.selectAll') }}
              </span>
            </f7-checkbox>

            <div class="content-pending__filters__buttons">
              <f7-button
                class="button-orange"
                :disabled="palletisingPointSelected === null || filteredSelectedList.length === 0"
                @click="RelatePalletizingPointsXProductionOutputs(1)"
              >
                Asignar
              </f7-button>

              <f7-button
                class="button-red"
                :disabled="filteredSelectedList.length === 0"
                @click="RelatePalletizingPointsXProductionOutputs(0)"
              >
                Desasignar
              </f7-button> <!-- -Todo cambiar por el selector de punto de paletizado -->

              <img
                height="40"
                alt="printButton"
                src="@/static/icons/ic_print-white.svg"
                @click="UpdateStatus(1)"
              >

              <img
                height="40"
                alt="noPrintButton"
                src="@/static/icons/ic_print-white-cancel.svg"
                @click="UpdateStatus(0)"
              >
            </div>
          </div>
          <div class="content-pending__results">
            <div
              v-for="i in 2"
              :key="i"
            >
              <UCPreload
                :show="showPendingPreload"
              />
            </div>
            <div
              v-for="(salidas, i) in lstProductionOutput"
              :key="i"
            >
              <UCCardGH
                :object-card="salidas"
                :title="salidas.SalidaProduccion.PuntoPaletizadoRelacionado != null ? salidas.SalidaProduccion.PuntoPaletizadoRelacionado.Nombre : '' "
                :slot-title="salidas.SalidaProduccion.DescripcionCorta"
                :show-selectable="true"
                :check-box-title="salidas.LineaPedidoVenta != null ? `${salidas.LineaPedidoVenta.PedidoVenta.Serie}/${salidas.LineaPedidoVenta.PedidoVenta.Numero}-${salidas.LineaPedidoVenta.Orden} ${salidas.LineaPedidoVenta.PedidoVenta.Cliente.Nombre}` : ''"
                :show-buttons="true"
                :card-title="salidas.TipoEnvasado != null ? (salidas.TipoEnvasado.Envase != null ? salidas.TipoEnvasado.Envase.Nombre : '') : ''"
                :card-sub-title="salidas.TipoEnvasado != null ? (salidas.TipoEnvasado.Articulo != null ? salidas.TipoEnvasado.Articulo.Nombre : '') : ''"
                :footer-item-lot="salidas.LoteActual != null ? salidas.LoteActual.Codigo : ''"
                :check-box-checked="allSelec"
                :no-assigned="salidas.SalidaProduccion.PuntoPaletizadoRelacionado != null ? true : false"
                :number-packages="salidas.SalidaProduccion.hasOwnProperty('EnvasesConfeccionados') && salidas.SalidaProduccion.EnvasesConfeccionados.length !== 0
                  ? `${salidas.SalidaProduccion.EnvasesConfeccionados[0].CantidadEnvasesReservadosPuntoPaletizado} ${$t('common.of')} ${salidas.SalidaProduccion.EnvasesConfeccionados[0].CantidadEnvasesPorPale}` : ''"
                :item-number-palets="false"
                :in-production="salidas.SalidaProduccion.EnProduccion"
                :change-to-red="salidas.SalidaProduccion.hasOwnProperty('EnvasesConfeccionados') && salidas.SalidaProduccion.EnvasesConfeccionados.length !== 0
                  && salidas.SalidaProduccion.EnvasesConfeccionados[0].CantidadEnvasesReservadosPuntoPaletizado > salidas.SalidaProduccion.EnvasesConfeccionados[0].CantidadEnvasesPorPale"
                :change-to-orange="salidas.SalidaProduccion.PuntoPaletizadoRelacionado != null && palletisingPointSelected != null && salidas.SalidaProduccion.PuntoPaletizadoRelacionado.Id === palletisingPointSelected.Id"
                @selected-object="EventSelectedLines"
                @edit-selected="EventPlanEdit(salidas)"
                @print-selected="EventPlanPrint(salidas)"
              />
            </div>
            <!-- <pre>{{ lstProductionOutput }}</pre> -->
          </div>
        </f7-col>
      </f7-row>
    </div>
    <!-- Popup Asignación desde Pedido -->
    <f7-popup
      class="asociateOrder-popup"
      :opened="popupPedidosPlanificados"
      @popup:closed="popupPedidosPlanificados = false"
    >
      <f7-navbar
        :title="$t('production.common.availableSalesOrders')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupPedidosPlanificados = false; addButtonPressed = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <FrmPlannedOrdersPalletizingPoint
        :activo="popupPedidosPlanificados"
        tipo-de-elemento-edicion="SalidaProduccion"
        @pedido-establecido="OrderEstablishedForPalletizingPoint()"
        @cerrar-frm="popupPedidosPlanificados = false; addButtonPressed = false"
      />
    </f7-popup>
    <!-- Popup Edicion de Pedido -->
    <f7-popup
      class="edicionPedidoPlanificado-popup"
      :opened="popupEdicionPedidoPlanificadoAbierto"
      @popup:closed="popupEdicionPedidoPlanificadoAbierto = false"
    >
      <f7-navbar
        :title="$t('production.editPallet.title')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupEdicionPedidoPlanificadoAbierto = false">
            <img :src="icClose">
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <FrmEditTypeOfPackaging
        :activo="popupEdicionPedidoPlanificadoAbierto"
        :mostrar-navbar-frm="false"
        tipo-de-elemento-edicion="SalidaProduccion"
        :elemento-produccion="salidaSeleccionada != null ? salidaSeleccionada.SalidaProduccion : null"
        :elementos-ocultar="['cantidadEnvasesPorPale']"
        @tipo-envasado-actualizado="ModifiedActivePalletPackagingType()"
      />
    </f7-popup>
    <f7-popup
      class="manageproductionoutputs-popup-images"
      :opened="popupImagenes"
      @popup:closed="popupImagenes = false"
    >
      <f7-navbar
        :title="$t('common.files')"
        sliding
        :style="appTheme"
      >
        <f7-nav-right>
          <f7-link @click="popupImagenes = false">
            <img
              :src="icClose"
              style="padding-right: 10px;"
            >
          </f7-link>
        </f7-nav-right>
      </f7-navbar>
      <PCImagenesEntidad
        v-if="idEntidad != null"
        :is-active="popupImagenes"
        :entity-id="idEntidad"
        @open-pdf="popupImagenes = false"
      />
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useSettingRef } from '@erpagroapp/settings';

import FrmPlannedOrdersPalletizingPoint from '@/pages/production/traceability/palletizing/FrmPlannedOrdersPalletizingPoint.vue';
import UCCardGH from '@/components/common/UCCardGH.vue';
import { Log } from '@/js/common/HIDebuggingSupport';
import UCPreload from '@/components/common/UCPreload.vue';
import FrmEditTypeOfPackaging from '@/pages/production/traceability/palletizing/FrmLineItemEditing.vue';
import icClose from '@/static/icons/ic_close.svg';
import GalleryIcon from '@/static/img/ic_gallery.svg';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { LOGO_HISPATEC } from '@/js/common/constants';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import ConexionTA, { callPlanificarPedidoEnPuntoPaletizado } from '@/js/services/traceability/APITraceability';
import PCImagenesEntidad from '@/components/production/traceability/PCImagenesEntidad.vue';
import PCSideNavbar from '@/components/common/PCSideNavbar.vue';
import { sleep } from '@/js/utils/sleep';

export default {
  name: 'FrmManageProductionOutputs',
  components: {
    PCSideNavbar,
    UCPreload,
    FrmEditTypeOfPackaging,
    UCSearchEntityERP,
    FrmPlannedOrdersPalletizingPoint,
    UCCardGH,
    PCImagenesEntidad,
  },

  data() {
    return {
      lineSelected: null, // Mantiene la linea seleccionada.
      lstPalletisingPoint: [], // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      lstPalletisingPointAndConfection: [], // Mantiene los puntos de paletizado de la linea de produccion selecctionada.
      palletisingPointSelected: null, // Mantiene el punto de paletizado seleccionado.
      counterCallsPendingAnswerInFrm: 0, // Contador de llamadas pendientes en el formulario.
      lineSelectedAtStartForm: null, // Linea de producción seleccionada al iniciar el formulario.
      lstProductionOutput: [], // Lista de salidas de producción de la linea seleccionada.
      lstLots: [],
      lstPlanningOrders: [],
      lstContainersQuantity: [],
      popupPedidosPlanificados: false, // Controla la apertura del popup de pedidos.
      popupEdicionPedidoPlanificadoAbierto: false,
      popupImagenes: false,
      idEntidad: null, // id de la entidad a pasar a PCImagenes entidad

      /**
       * Mantiene el timer que realiza las actualizaciones automáticas.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomatico: null,

      lstSelected: [],
      icClose,
      GalleryIcon,
      allSelec: false,
      showPendingPreload: false,
      showLotsPreload: false,
      showPlanPreload: false,
      addButtonPressed: false,
      salidaSeleccionada: null,
      tipoEnvasadoElementoProduccionSeleccionadoLocal: null,
      lineasProduccion: null,
      LOGO_HISPATEC,
      logoApp: useSettingRef('App.Logo'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, [
      'pedidoPlanificadoSeleccionado',
      'getLineasProduccion',
    ]),

    ...mapWritableState(useTraceabilityStore, [
      'tipoEnvasadoElementoProduccionSeleccionado',
      'puntoDePaletizadoSeleccionado',
      'lineaDeProduccionSeleccionada',
    ]),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },

    filteredSelectedList() {
      return this.lstSelected.filter((e) => e.Seleccionada === true);
    },
  },

  watch: {
    tiposEnvasadoPuntosDePaletizado(val) {
      this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado = val; // Almacenamos en la variable global para posibles recuperaciones.
    },
  },

  mounted() {
    this.InitFrm();
  },

  unmounted() {
    this.PararIntervaloActualizacionesAutomaticas();
  },

  methods: {
    InitFrm() {
      Log(this, this.InitFrm.name);
      // Sol.221815  - Cuando salgo para volcar y vuelvo a entrar en el paletizado, debe seguir cargada la última línea que estuvo seleccionada.
      this.lineSelectedAtStartForm = this.lineaDeProduccionSeleccionada;
      // sol.222038 - Si lineSelectedAtStartForm es null obtenemos la linea por defecto definida en el trabajador.
      this.lineSelectedAtStartForm ??= this.lineasDeProduccionDelUsuarioDefinidaEnERP;
      this.tiposEnvasadoPuntosDePaletizado = this.coleccionTiposDeEnvasadosEstablecidosEnLosPuntosDePaletizado;
      this.puntoDePaletizadoSeleccionado = null;
      this.ConfigurePersonalisationsFrm();

      this.lineasProduccion = this.getLineasProduccion;
      // this.puntosDePaletizado = this.lineasProduccion.PuntosDePaletizado;
    },

    ConfigurePersonalisationsFrm() {
      Log(this, this.ConfigurePersonalisationsFrm.name);
    },
    /* Método UpdateDataFrm */
    async UpdateDataFrm() {
      Log(this, this.UpdateDataFrm.name);
      this.lstSelected = [];
      this.lstPalletisingPoint = [];
      this.lstPalletisingPointAndConfection = [];
      this.palletisingPointSelected = null;
      await sleep(100);
      if (this.lineSelected != null) {
        this.lstPalletisingPoint = this.lineSelected.PuntosDePaletizado;
        this.LoadProductionOutlets(this.lineSelected);
        // this.UpdateProductionOutlets(this.lineSelected);
        this.lstPalletisingPointAndConfection = this.GenerateStructureConfectionPP();
        await this.LoadPlanningPointsPalletisingLine(this.lineSelected);
      }
    },

    OpenImagenesEntidad(planificacion) {
      Log(this, this.OpenImagenesEntidad.name);
      this.idEntidad = planificacion.IdPedidoVenta;
      this.popupImagenes = true;
    },

    GenerateStructureConfectionPP() {
      Log(this, this.GenerateStructureConfectionPP.name);
      const listStructure = [];
      this.lstPalletisingPoint.forEach((pp) => {
        listStructure.push(
          {
            PuntoPaletizado: pp,
            Planificaciones: [],
          },
        );
      });

      return listStructure;
    },

    PararIntervaloActualizacionesAutomaticas() {
      Log(this, this.PararIntervaloActualizacionesAutomaticas.name);
      if (this.actualizadorAutomatico) {
        clearInterval(this.actualizadorAutomatico);
        this.actualizadorAutomatico = null;
      }
    },

    ProgramarIntervaloActualizacionesAutomaticas() {
      Log(this, this.ProgramarIntervaloActualizacionesAutomaticas.name);

      this.actualizadorAutomatico = setInterval(() => {
        if (this.popupPedidosPlanificados || this.popupEdicionPedidoPlanificadoAbierto) {
          return;
        }

        this.GetNumberOfContainers();
      }, 30 * 1000);
    },

    async LoadPlanningPointsPalletisingLine(objLine) {
      Log(this, this.LoadPlanningPointsPalletisingLine.name);
      this.showPlanPreload = true;

      const result = await this.GetPlanningPointsPalletisingLine(objLine.Id);

      this.lstPalletisingPointAndConfection.forEach((element) => {
        element.Planificaciones = result.filter((r) => r.PuntoPaletizado.Id === element.PuntoPaletizado.Id);
      });

      /* Ordenamos por tipo de estado */
      this.showPlanPreload = false;
      this.lstPalletisingPointAndConfection.sort((a, b) => {
        if (a.Planificaciones.TipoEstado < b.Planificaciones.TipoEstado) {
          return 1;
        }
        if (a.Planificaciones.TipoEstado > b.Planificaciones.TipoEstado) {
          return -1;
        }
        return 0;
      });

      /* Añadimos el campo seleccionado a las planificaciones para poder seleccionar cada tarjeta */
      for (let i = 0; i < this.lstPalletisingPointAndConfection.length; i += 1) {
        const element = this.lstPalletisingPointAndConfection[i];
        for (let j = 0; j < element.Planificaciones.length; j += 1) {
          const elementt = element.Planificaciones[j];
          elementt.seleccionado = false;
        }
      }
    },

    async GetNumberOfContainers() {
      let idsPuntoPaletizado = '';
      this.lstPalletisingPointAndConfection.forEach((element) => {
        idsPuntoPaletizado += `${element.PuntoPaletizado.Id},`;
      });
      this.lstContainersQuantity = await this.GetPlanningQuantitiesProducedXPalletizingPoints(idsPuntoPaletizado.substring(0, idsPuntoPaletizado.length - 1));

      /* Obtenemos la cantidad de envases confeccionados */
      this.lstProductionOutput.forEach((e) => {
        e.SalidaProduccion.EnvasesConfeccionados = this.lstContainersQuantity.filter((f) => e.SalidaProduccion.PuntoPaletizadoRelacionado != null
          && e.SalidaProduccion.PuntoPaletizadoRelacionado.Id === f.PuntoPaletizado.Id);
      });
    },

    async LoadProductionOutlets(objLine) {
      Log(this, this.LoadProductionOutlets.name);
      await this.UpdateProductionOutlets(objLine);
    },

    async UpdateProductionOutlets(objLine) {
      Log(this, this.UpdateProductionOutlets.name);
      this.showPendingPreload = true;
      this.lstProductionOutput = [];
      this.lstProductionOutput = await this.GetProductionOutletsXLine(objLine.Id);
      this.lstSelected = this.lstProductionOutput;
      this.showPendingPreload = false;

      await this.GetNumberOfContainers();
    },

    async LoadDumpLotsXPalletizingPoints(objPalletisingPoint) {
      Log(this, this.LoadDumpLotsXPalletizingPoints.name);
      this.showLotsPreload = true;
      this.lstLots = [];
      const result = await this.GetDumpLotsXPalletizingPoints(objPalletisingPoint.Id, new Date().toISOString());
      this.lstLots = result;

      // ordenar por no finalizados
      this.lstLots.sort((a, b) => {
        if (a.FechaInicio < b.FechaInicio) {
          return 1;
        }
        if (a.FechaInicio > b.FechaInicio) {
          return -1;
        }
        return 0;
      });

      this.showLotsPreload = false;
    },

    async LoadPendingPlanningOrders(productionLine) {
      Log(this, this.LoadPendingPlanningOrders.name);
      const result = await this.GetPendingPlanningOrdersXProductionLine(productionLine.Id);
      this.lstPlanningOrders = result;
    },

    async OrderEstablishedForPalletizingPoint() {
      Log(this, this.OrderEstablishedForPalletizingPoint.name);
      HiDialog.Preloader(true, this.$t('AsinLineaPedPuntoPal'), false);
      const tempPedidoAsignadoEnPunto = { ...this.pedidoPlanificadoSeleccionado };

      await this.PlanOrderXPalletizingPoint({
        salesOrderLineId: tempPedidoAsignadoEnPunto.IdLineaPedidoVenta,
        palletizingPointId: this.puntoDePaletizadoSeleccionado.Id,
        productionLineId: this.lineaDeProduccionSeleccionada.Id,
        quantity: tempPedidoAsignadoEnPunto.CantidadPalet,
        productionOrderId: tempPedidoAsignadoEnPunto.OrdenProduccion.Id,
        plannedProductionOutputPartId: tempPedidoAsignadoEnPunto.ParteProduccionPrevistoSalida.Id,
      });
      HiDialog.Preloader(false);
      this.UpdateDataFrm();
    },

    async UpdateStatus(accion) {
      Log(this, this.UpdateStatus.name);
      // Seleccionamos solo las que tengan un punto de paletizado
      const list = this.filteredSelectedList.filter((f) => f.SalidaProduccion.PuntoPaletizadoRelacionado !== null);

      if (list.length === 0) {
        HiNotification.Toast('No hay salidas seleccionadas');
        return;
      }
      this.lstSelected = this.lstProductionOutput;

      const outputs = [];
      if (accion === 1) {
        list.forEach((e) => {
          e.SalidaProduccion.EnProduccion = true;
          outputs.push(e.SalidaProduccion);
        });
      } else {
        list.forEach((e) => {
          e.SalidaProduccion.EnProduccion = false;
          outputs.push(e.SalidaProduccion);
        });
      }
      HiDialog.Preloader(true, this.$t('ActuSalProd'), false);
      await this.UpdateProductionStatusXProductionOutputs(outputs);
      this.allSelec = false;
      HiDialog.Preloader(false);
      this.UpdateDataFrm();
    },

    ModifiedActivePalletPackagingType() {
      Log(this, this.ModifiedActivePalletPackagingType.name);

      if (this.tipoEnvasadoElementoProduccionSeleccionado != null) {
        this.tipoEnvasadoElementoProduccionSeleccionadoLocal = { ...this.tipoEnvasadoElementoProduccionSeleccionado };
        this.salidaSeleccionada.LineaPedidoVenta.InfoEnvase = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Envase;
        this.salidaSeleccionada.LineaPedidoVenta.InfoPale = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Pale;
        this.salidaSeleccionada.LineaPedidoVenta.InfoProducto = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.Articulo;
        this.salidaSeleccionada.LineaPedidoVenta.EnvasesPorPalet = this.tipoEnvasadoElementoProduccionSeleccionadoLocal.EnvasesPorPale;

        this.lstProductionOutput.find((s) => s.LineaPedidoVenta !== null && s.LineaPedidoVenta.Id === this.salidaSeleccionada.LineaPedidoVenta.Id).LineaPedidoVenta = this.salidaSeleccionada.LineaPedidoVenta;
      }

      this.popupEdicionPedidoPlanificadoAbierto = false;
    },

    FormatDate(fecha) {
      return `${SoporteFechaYHora.ObtenerDiaMesAno(fecha)} - ${SoporteFechaYHora.obtenerHorasYMinutos(fecha)}`;
    },

    EventPalletisingPointSelected(puntoSeleccionado) {
      Log(this, this.EventPalletisingPointSelected.name);
      if (puntoSeleccionado == null) {
        this.palletisingPointSelected = null;
        return;
      }

      if (puntoSeleccionado === this.palletisingPointSelected) {
        return;
      }
      this.palletisingPointSelected = puntoSeleccionado.PuntoPaletizado;
    },
    onBeforeOpen() {
      Log(this, this.onBeforeOpen.name);
    },
    EventPlanEdit(salida) {
      Log(this, this.EventPlanEdit.name);

      let tempEnvasadoElementoProduccionSeleccionadoLocal = null;
      if (this.tipoEnvasadoElementoProduccionSeleccionado != null) {
        this.tipoEnvasadoElementoProduccionSeleccionadoLocal = { ...this.tipoEnvasadoElementoProduccionSeleccionado };
      }

      if (this.tipoEnvasadoElementoProduccionSeleccionadoLocal === null) {
        tempEnvasadoElementoProduccionSeleccionadoLocal = {
          Id: salida.TipoEnvasado.Id,
          Pale: salida.TipoEnvasado.Pale,
          Articulo: salida.TipoEnvasado.Articulo,
          Envase: salida.TipoEnvasado.Envase,
          Marca: salida.TipoEnvasado.Marca,
          EnvasesPorPale: salida.TipoEnvasado.EnvasesPorPale,
          /*
          Id: salida.LineaPedidoVenta.Id,
          Pale: salida.LineaPedidoVenta.InfoPale,
          Articulo: salida.LineaPedidoVenta.InfoProducto,
          Envase: salida.LineaPedidoVenta.InfoEnvase,
          Marca: null,
          EnvasesPorPale: salida.LineaPedidoVenta.EnvasesPorPalet,
          */
        };

        this.tipoEnvasadoElementoProduccionSeleccionado = tempEnvasadoElementoProduccionSeleccionadoLocal;
      }

      this.salidaSeleccionada = salida;
      this.popupEdicionPedidoPlanificadoAbierto = true;
    },
    async EventPlanPrint(salida) {
      Log(this, this.EventPlanPrint.name);
      const outputs = [];
      salida.SalidaProduccion.EnProduccion = !salida.SalidaProduccion.EnProduccion;
      outputs.push(salida.SalidaProduccion);
      HiDialog.Preloader(true, this.$t('ActuSalProd'), false);
      await this.UpdateProductionStatusXProductionOutputs(outputs);
      HiDialog.Preloader(false);
      this.UpdateDataFrm();
    },

    EventPalletizingPointSelected(palletizingPoint) {
      Log(this, this.EventPalletizingPointSelected.name);
      this.puntoDePaletizadoSeleccionado = palletizingPoint.PuntoPaletizado;
      this.EventPalletisingPointSelected(palletizingPoint);
      this.LoadDumpLotsXPalletizingPoints(palletizingPoint.PuntoPaletizado);
    },

    async EventLineProductionSelected(lineSelected) {
      Log(this, this.EventLineProductionSelected.name);

      if (lineSelected != null) {
        this.lineaDeProduccionSeleccionada = lineSelected;
      }

      this.palletisingPointSelected = null;
      this.lineSelected = lineSelected;

      if (lineSelected == null) {
        this.lstPalletisingPoint = [];
        this.lstPalletisingPointAndConfection = [];
        this.lstProductionOutput = [];
        this.PararIntervaloActualizacionesAutomaticas();
        return;
      }

      this.lstPalletisingPoint = lineSelected.PuntosDePaletizado;
      this.lstPalletisingPointAndConfection = this.GenerateStructureConfectionPP();
      this.LoadPlanningPointsPalletisingLine(lineSelected); // Cargar planificaciones punto paletizado.
      this.LoadProductionOutlets(lineSelected); // Cargar Salidas de producción de la linea.

      if (lineSelected === null) {
        this.lstLots = [];
      }

      if (this.lstPalletisingPoint.length === 0) {
        this.PararIntervaloActualizacionesAutomaticas();

        HiNotification.Toast('La Linea seleccionada no dispone de puntos de paletizado');
      } else if (!this.actualizadorAutomatico) {
        this.ProgramarIntervaloActualizacionesAutomaticas();
      }
    },

    EventSelectedLines(object) {
      Log(this, this.EventSelectedLines.name);

      this.lstSelected.forEach((element) => {
        if (object.SalidaProduccion.Id === element.SalidaProduccion.Id) {
          element.Seleccionada = object.Seleccionada;
        }
      });
    },

    EventAllSelected(e) {
      Log(this, this.EventAsociateOrder.name);

      this.lstSelected.forEach((i) => {
        i.Seleccionada = e.target.checked;
      });

      this.allSelec = e.target.checked;
    },

    EventAsociateOrder() {
      Log(this, this.EventAsociateOrder.name);
    },

    GetPlanningPointsPalletisingLine(idLine) {
      Log(this, this.GetPlanningPointsPalletisingLine.name);
      return ConexionTA.callPlanificacionesEnPuntosPaletizadoXLinea(idLine);
    },

    GetProductionOutletsXLine(idLine) {
      Log(this, this.GetProductionOutletsXLine.name);
      return ConexionTA.callProductionOutletsXLine(idLine);
    },

    GetDumpLotsXPalletizingPoints(idPalletizingPoint, date) {
      Log(this, this.GetDumpLotsXPalletizingPoints.name);
      return ConexionTA.callDumpLotsXPalletizingPoints(idPalletizingPoint, date, false);
    },

    GetPendingPlanningOrdersXProductionLine() {
      Log(this, this.GetPendingPlanningOrdersXProductionLine.name);
      return ConexionTA.callObtenerPedidosPendientesPlanificacionXLineaProduccion(this.lineSelected.Id);
    },

    /**
     * Plans the order.
     * @param {Parameters<typeof callPlanificarPedidoEnPuntoPaletizado>[0]} data
     */
    PlanOrderXPalletizingPoint(data) {
      Log(this, this.PlanOrderXPalletizingPoint.name);
      return callPlanificarPedidoEnPuntoPaletizado(data);
    },

    async UpdateProductionStatusXProductionOutputs(outputs) {
      Log(this, this.UpdateProductionStatusXProductionOutputs.name);
      const res = await ConexionTA.callUpdateProductionStatusXProductionOutputs(outputs, 0);
      if (res[0].Valor) {
        return true;
      }
      HiNotification.Toast(`Movimiento no realizado. ${res[0].Mensaje}`);
      return false;
    },

    async RelatePalletizingPointsXProductionOutputs(accion) {
      Log(this, this.RelatePalletizingPointsXProductionOutputs.name);
      const outputs = [];
      if (accion === 1 && this.palletisingPointSelected === null) {
        HiNotification.Toast('Movimiento no realizado. No se ha indicado punto de paletizado a relacionar');
        return false;
      }

      if (this.filteredSelectedList === null) {
        HiNotification.Toast('Movimiento no realizado. No se ha indicado ninguna salida de producción');
        return false;
      }

      if (accion === 1) {
        this.filteredSelectedList.forEach((e) => {
          e.SalidaProduccion.PuntoPaletizadoRelacionado = this.palletisingPointSelected;
          outputs.push(e.SalidaProduccion);
        });
      } else {
        this.filteredSelectedList.forEach((e) => {
          e.SalidaProduccion.PuntoPaletizadoRelacionado = null;
          outputs.push(e.SalidaProduccion);
        });
      }

      HiDialog.Preloader(true, this.$t('AsinSalProdPunto'), false);
      const res = await ConexionTA.callUpdateProductionStatusXProductionOutputs(outputs, 1);
      HiDialog.Preloader(false);

      this.lstSelected = this.lstProductionOutput;
      this.allSelec = false;
      await this.UpdateDataFrm();

      if (res[0].Valor) {
        return true;
      }

      HiNotification.Toast(`Movimiento no realizado. ${res[0].Mensaje}`);
      return false;
    },

    GetPlanningQuantitiesProducedXPalletizingPoints(idsPuntosPaletizado) {
      Log(this, this.GetPlanningQuantitiesProducedXPalletizingPoints.name);
      const res = ConexionTA.callGetPlanningQuantitiesProducedXPalletizingPoints(idsPuntosPaletizado);
      return res;
    },
  },
};
</script>

<style lang="scss">
.asociateOrder-popup {
  --f7-navbar-inner-padding-right: 15px;

  .card-info-content-title__title,
  .card-info-subtitle,
  .card-info-content-text {
    margin-left: 0 !important;
  }

  .link-izquierdaActions-2 {
    color: #c1c1c1 !important;
  }

  .link-derechaActions-2 {
    color: var(--his-mandarina) !important;
  }
}

.card-info-content-footer {
  &__items {
    color: red;
    font-size: 20px;
  }
}

.main-manageproductionoutputs {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-checkbox-border-radius: 2px;
  --f7-checkbox-inactive-color: var(--his-blueberry-frost);
  --f7-list-font-size: 16px;
  --f7-list-item-padding-horizontal: 16px;
  --f7-list-item-min-height: 48px;
  --f7-list-item-title-font-size: 15px;
  --f7-list-border-color: rgb(0 0 0 / 12%);
  --f7-list-chevron-icon-font-size: 20px;

  .icon-checkbox,
  .checkbox i {
    background-color: transparent;
  }
  //

  --available-viewport-height: calc(100vh - var(--information-bar-height));
  --information-bar-padding-bottom: 0;

  .page-content {
    display: flex;

    .content-menu {
      background-color: #ebecf0;
      box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
      width: 80px;
    }

    .content-data {
      width: 100%;
      box-sizing: border-box;
    }

    .content-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &__actions {
        display: flex;
        align-items: center;

        &--button {
          border: 1px solid #dbe6f1;
          background-color: #e5eef7a9;
          color: var(--his-plum-shadow);
          font-size: 14px;
          font-weight: 500;
          height: 41px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          margin-right: 16px;
          border-radius: 3px;

          img {
            margin-right: 10px;
            height: 16px;
            width: 16px;
          }

          .badge-indicadorActualizacionAPP {
            left: 12px;
            background: var(--his-tomate);
          }
        }
      }

      &__logo {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: auto;
          height: 44px;
          border-radius: 6px;
          box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
        }
      }
    }

    .content-body {
      height: calc(var(--available-viewport-height) - 76px);

      // overflow-y: hidden;
    }

    .content-planned,
    .content-pending {
      height: calc(var(--available-viewport-height) - 80px);
      background-color: #ebecf0;

      &__title {
        display: flex;
        justify-content: space-between;
        background-color: var(--his-soft-blue);
        font-weight: 500;
        color: var(--his-steel-blue);
        font-size: 13px;
        margin-bottom: 5px;

        span {
          align-items: center;
          display: flex;
          padding: 10px 18px;
        }

        .button-asigned {
          display: flex;
          justify-content: flex;
          align-items: center;
          height: 35px;
        }
      }

      &__filters {
        color: var(--his-bg);
        background-color: var(--his-plum-shadow);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 12px;
        border-radius: 6px 6px 0 0;

        &__buttons {
          display: flex;
          justify-content: flex-end;

          :nth-child(n) {
            margin-left: 12px;
          }

          .button {
            font-size: 14px;
            color: #fff;
            height: 40px;

            &.button-orange {
              background-color: var(--his-mandarina);
            }

            &.button-red {
              background-color: var(--his-tomate);
            }
          }
        }

        &__checkbox {
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          background-color: #f5f6f7;
          padding: 0 16px 0 8px;
          border-radius: 4px;

          span {
            line-height: 1;
            color: var(--his-steel-blue);
            font-size: 13px;
          }
        }
      }

      &__results {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5px;
        background-color: #ebecf0;
        overflow-y: scroll;
        height: calc(var(--available-viewport-height) - 61.6px - 38.2px - 60px - 20px);
      }

      &__results--cards {
        background-color: #ebecf0;
        height: calc(var(--available-viewport-height) - 74px - 28.8px - 71.8px - 203.2px);
        overflow-y: scroll;

        .content-button {
          display: flex;
          align-items: flex-start;
          border-radius: 4px;
          -webkit-border-radius: 4px;
        }

        .accordion-list {
          .accordion-item-opened {
            .item-link {
              .item-content {
                background-color: var(--his-steel-blue) !important;
              }
            }
          }

          .accordion-item {
            background-color: #ebecf0;

            .item-link {
              .item-content {
                background: top;
                background-color: var(--his-plum-shadow);
                margin-bottom: 5px;

                .item-inner {
                  .item-title {
                    font-weight: 400;
                    color: var(--his-whispering-lilac);
                  }

                  &::after {
                    height: 0 !important;
                  }
                }
              }

              .item-content::before {
                color: #fff;
                height: 100%;
              }
            }
          }
        }
      }

      &__results--lotes {
        --first-calc: calc(var(--available-viewport-height) - 61.6px - 38.2px - 75.2px);
        --second-calc: calc(var(--available-viewport-height) - 74px - 28.8px - 71.8px - 203.2px);
        --f7-list-item-title-text-color: var(--his-dark-blue);

        height: calc(var(--first-calc) - var(--second-calc));
        overflow-y: scroll;
        box-sizing: content-box;

        .item-500 {
          --f7-list-item-title-font-weight: 500;
          --f7-list-item-after-font-weight: 500;
        }

        .item-600 {
          --f7-list-item-title-font-weight: 600;
          --f7-list-item-after-font-weight: 600;
        }
      }
    }

    // .content-planned {
    //   &__results {
    //     > div {
    //       height: calc(100% - 60px);
    //     }
    //   }
    // }
  }

  .line-production {
    width: 35vw;
  }

  .page {
    background-color: #f7f7f7;
  }

  .div-contenido {
    margin-left: 100px;
    margin-right: 10px;
  }

  .menu {
    background-color: #ebecf0;
    box-shadow: 1px 0 1px 0 rgb(9 30 66 / 25%), 0 0 1px 0 rgb(9 30 66 / 31%);
    width: 80px;
    height: 100vh;
    float: left;
  }

  /*  Estilos de las listas Dragg */
  .sortable-ghost {
    max-height: 34px;
    background: #fff;
    overflow: hidden;
    display: block;
  }

  .sortable-fallback {
    background: #fff;
    border: 2px solid yellow;
    opacity: 1 !important;
    overflow: hidden;
    max-height: 50px;
  }

  .btn-actualizarPedidosPendientesDePlanificar {
    float: right;
    margin-right: 16px;
  }

  .btn-actualizarPedidosPendientesDePlanificarDeshabilitado {
    opacity: 0.3;
    pointer-events: none;
  }

  .div-opcionesActions {
    /*
      width: 87%;
      bottom: 10px;
      position: absolute;
      */
    margin-top: 40px;
    margin-bottom: 15px;
    margin-right: 30px;
  }

  .div-separador {
    width: 94%;
    bottom: 45px;
    position: absolute;
  }

  .div-cabeceraFormularioEdicionDePedidoPopupContenido {
    margin-left: 22px;
    margin-top: 10px;
  }

  .div-rectanguloPedidoDivido {
    background-color: #ff3b30;
    border-radius: 3px;
    width: 30px;
    height: 19px;
    text-align: center;
  }

  .div-rectanguloPedidoDivido span {
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
  }

  .div-operacionesFormularioEdicionDePedidoPopupContenido {
    /* margin-left: 22px; */
    margin-top: 10px;
  }

  .btn-edicion {
    position: absolute;
    top: 35px;
    right: -6px;
  }

  .col-btnEdicion-planificados {
    position: relative;
  }

  .col-btnEdicion-sinPlanificar {
    position: relative;
    padding-left: 7px;
    padding-top: 5px;
  }

  .div-elementoTarjetaLineaDeshabilitada {
    opacity: 0.3;
    pointer-events: none;
  }

  .div-logoHispatecDerecha {
    max-width: 250px;
    margin-top: 18px;
    border-left: 1px solid rgb(151 151 151 / 30%);
    text-align: end;
    padding-right: 15px;
  }

  .img-logoHispatec {
    padding-left: 45px;
  }
}

.popup-distribuirPlanificacion {
  --f7-navbar-height: 44px;
  --f7-navbar-title-font-size: 16px;
  --f7-navbar-bg-color: var(--his-silver);
  --f7-popup-tablet-height: 90vh !important;

  .navbar ~ .page-content {
    padding-top: var(--f7-page-navbar-offset);
  }

  .content-button {
    display: flex;
    justify-content: space-between;
    --f7-button-font-size: 16px;
  }
}

.manageproductionoutputs-popup-images {
  overflow-y: scroll;
}
</style>
